export default __webpack_public_path__ + "static/media/IconRecordAnimals.1438fe75.svg";